import axios from "axios";

const API =
  process.env
    .REACT_APP_API_URL ||
  "http://localhost:5000";

export const getModules =
  async () => {
    const response =
      await axios.get(
        `${API}/permissions/modules`,
        {
          withCredentials:
            true,
        }
      );

    return response.data;
  };

export const getPermissions =
  async () => {
    const response =
      await axios.get(
        `${API}/permissions/list`,
        {
          withCredentials:
            true,
        }
      );

    return response.data;
  };

export const getRoleDetails =
  async (roleId) => {
    const response =
      await axios.get(
        `${API}/roles/${roleId}`,
        {
          withCredentials:
            true,
        }
      );

    return response.data;
  };

export const assignModules =
  async (
    roleId,
    moduleIds
  ) => {
    const response =
      await axios.put(
        `${API}/roles/modules/${roleId}`,
        {
          moduleIds,
        },
        {
          withCredentials:
            true,
        }
      );

    return response.data;
  };

export const assignPermissions =
  async (
    roleId,
    permissionIds
  ) => {
    const response =
      await axios.put(
        `${API}/roles/permissions/${roleId}`,
        {
          permissionIds,
        },
        {
          withCredentials:
            true,
        }
      );

    return response.data;
  };